import { BrowserStorage, MemoryStore, MigrosTokenProvider } from '@migros/tokenprovider';
import { getAccessToken } from 'api/token';
import { isNativePlatformAndroid, isNativePlatformIOS } from 'components/helper/Platform';
import { getAuthToken } from 'helper/get-auth-token';
import appConfig from 'helper/mapBackendConfig';

/**
 * Provide Token for MUI widgets when used inside the Native WebView
 * @see https://jira.migros.net/browse/PULSWM-4073
 */

/* tslint:disable */
declare global {
	interface Window {
		MigrosTokenProvider: any;
	}
}
/* tslint:enable */

// update the token for the MigrosTokenProvider
export async function updateMigrosTokenProviderToken(): Promise<void> {
	if (!window.MigrosTokenProvider) {
		return void 0;
	}

	if (isNativePlatformIOS() || isNativePlatformAndroid()) {
		getAuthToken().then((token) => {
			window.MigrosTokenProvider.setAccessToken(token);
		});
	} else {
		const accessToken = await getAccessToken();
		await window.MigrosTokenProvider.setAccessToken(accessToken);

		// get token every 5 minutes
		setInterval(async () => {
			const token = await getAccessToken();
			await window.MigrosTokenProvider.setAccessToken(token);
		}, 5 * 60 * 1000);
	}
}

// setup MigrosTokenProvider on the window object
export async function initMigrosTokenProvider() {
	if (typeof window === 'undefined') {
		return null;
	}

	if (window.MigrosTokenProvider) {
		return window.MigrosTokenProvider;
	}

	const provider = new MigrosTokenProvider(window, new BrowserStorage(new MemoryStore()));

	window.MigrosTokenProvider = provider;

	if (!isNativePlatformIOS() && !isNativePlatformAndroid()) {
		await window.msrc.utilities.login.tokenProviderSetup({
			loginEvent: async () => {
				window.location.href = appConfig.env.msrcConfig.loginEndpoint;
			},
			logoutEvent: async () => {
				window.location.href = appConfig.env.msrcConfig.logoutEndpoint;
			},
		});
	}

	await updateMigrosTokenProviderToken();

	return provider;
}
